// extracted by mini-css-extract-plugin
export default {"container":"NewsHome_container__FRFEB","subcontainer1":"NewsHome_subcontainer1__Vmpc7","subcontainer2":"NewsHome_subcontainer2__hqxPG"};